import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerList = {
  gamePartnerList: { data: null, loading: false, error: null },
};

export const gamePartnerList = createAsyncThunk('user/gamePartnerList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/game/partner/list`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerList = {
  [gamePartnerList.pending]: (state) => {
    state.gamePartnerList.loading = true;
  },
  [gamePartnerList.fulfilled]: (state, action) => {
    state.gamePartnerList.loading = false;
    state.gamePartnerList.data = action.payload;
    state.gamePartnerList.error = null;
  },
  [gamePartnerList.rejected]: (state, action) => {
    state.gamePartnerList.loading = false;
    state.gamePartnerList.error = action.payload;
  },
};
